// Sidebar entries owned by the Contract module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { resources, scopes } from '@/utils/permission'
import { contractPaths } from './paths'

export const contractNav = {
    customer: {
        title: 'contract:sidebar_customer',
        path: contractPaths.customerContractList,
        rsname: resources.contractsCustomers,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
    partner: {
        title: 'contract:sidebar_partner',
        path: contractPaths.partnerContractList,
        // API widened to Contracts Partners OR Customers create/update (BOM, Finance,
        // CSKH, Sale). The sidebar HOC checks a single rsname; Contracts Customers `index`
        // is held by exactly {CSKH, BOM, Finance, Sale}, matching that audience without
        // dropping Finance (Resellers/Affiliates/Partners are not Keycloak resources).
        rsname: resources.contractsCustomers,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
    sample: {
        title: 'contract:sidebar_sample',
        path: contractPaths.sampleContractList,
        rsname: resources.contractsSample,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
    negotiation: {
        title: 'contract:sidebar_negotiation',
        path: contractPaths.contractNegotiation,
        rsname: resources.contractsCustomers,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
} satisfies Record<string, SidebarType>
